/**
 * Horizon: prevent automatic cart drawer opening after Add to Cart.
 * The cart can still be opened normally by clicking the cart icon.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  // Prevent Shopify's automatic openCart action.
  actions.openCart.configure({
    handler() {
      return Promise.resolve();
    },
  });

  // Safety net: if the cart drawer gets opened automatically after
  // a cart-lines update, close it when openCart:false was requested.
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event?.openCart === false || event?.detail?.openCart === false) {
      requestAnimationFrame(() => {
        const drawer = document.querySelector('theme-drawer#cart-drawer');

        if (drawer?.hasAttribute('open')) {
          drawer.removeAttribute('open');
        }

        if (drawer?.open && typeof drawer.close === 'function') {
          drawer.close();
        }
      });
    }
  });
}

if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}